import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: null,
  totalCount: 0,
  entities: null,
  lastError: null,
  appraisal_detail: null,
  errorState: null,
  submitted_question: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const appraisalPublishSlice = createSlice({
  name: "appraisal_publish",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    AppraisalPublishFetched: (state, action) => {
      const entities = action.payload.data?.data.rows;
      const totalResult = action.payload.data?.data.totalResults;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalResult;
    },

    AppraisalPublishDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    AppraisalPublishUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    AppraisalPublishBulkUpdated: (state, action) => {
      state.errorState = action.payload;
      state.actionsLoading = false;
    },
    clearErrorState: (state, action) => {
      state.errorState = null;
    },
    AppraisalDetailFetched: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.appraisal_detail = action.payload;
    },
    AppraisalPublishReportFetched: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    AppraisalPublishSubmittedQuestionFetched: (state, action) => {
      state.submitted_question = action.payload;
      state.error = null;
      state.actionsLoading = false;
    },
  },
});
